export const LocalStorageService = {
  setItem: (key, value) => {
    if (typeof value === "object") {
      localStorage.setItem(key, JSON.stringify(value));
    } else {
      localStorage.setItem(key, value);
    }
  },

  getItem: (key) => {
    const item = localStorage.getItem(key);
    if (!item || item === "undefined") return null;

    try {
        return JSON.parse(item);
    } catch {
      return item;
    }
  },

  removeItem: (key) => {
    localStorage.removeItem(key);
  },
};
